import debounce from 'lodash/debounce'
import { SEARCH_BOX } from '@plugins/service/api/urls'

export default {
  data () {
    return {
      search: '',
      isTyping: false,
      isLoading: false,
      courses: [],
      teachers: [],
      openList: false
    }
  },
  computed: {
    isListOpen () {
      return this.openList && this.search.length
    }
  },
  watch: {
    search: debounce(function () {
      this.isTyping = false
    }, 1000),
    isTyping (value) {
      if (!value) {
        if (this.search.length > 0) {
          this.searchInput(this.search)
        }
      }
    }
  },
  methods: {
    closeSearch () {
      this.search = ''
      this.openList = false
    },
    async searchInput () {
      try {
        this.isLoading = true
        const { data } = await this.$api.index({ url: SEARCH_BOX, query: { query: this.search } })
        const {
          courses = [],
          teachers = []
        } = data
        this.openList = true
        this.courses = courses
        this.teachers = teachers
      } catch (e) {
        this.$logger.captureException({ error: e })
      } finally {
        this.isLoading = false
      }
    },
    showList () {
      if (!this.search || this.openList) { return }
      if (this.courses.length || this.teachers.length) {
        this.openList = true
      }
    }
  }

}
